<template>
  <div class="flex justify-between">
    <div class="space-y-1">
      <Label v-if="workspace.current_subscription_plan" for="plan" class="mb-0">
        Change plan ({{ workspace.current_subscription_plan?.name }} -
        {{ workspace.current_subscription?.quantity }}
        {{ workspace.current_subscription?.quantity > 1 ? 'seats' : 'seat' }})
      </Label>
      <Label v-else for="plan" class="mb-0"> Change plan (Free) </Label>
      <p class="text-neutral-400 text-sm">Change your workspace plan</p>
    </div>
    <Button
      v-if="canResumeSubscription"
      size="sm"
      :loading="isPending"
      :disabled="isPending"
      @click="resumeSubscription"
    >
      Resume subscription
    </Button>
    <UpgradeModal v-else>
      <template #trigger>
        <Button variant="outline" :disabled="isPastDue" size="sm">
          Change
        </Button>
      </template>
    </UpgradeModal>
  </div>
  <ResumeNotice v-if="canResumeSubscription" />
  <p v-if="isPastDue" class="text-xs text-error-400 mt-1">
    Your subscription payment failed. Please
    <RouterLink
      :to="{ name: 'workspace-billing', query: { paymentMethod: true } }"
      class="text-error-400 hover:text-error-400 underline"
      >update your payment method</RouterLink
    >
    to avoid service interruption.
  </p>
</template>
<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { toast } from 'vue-sonner';

import { Label } from '@ui/components/label';
import { Button } from '@ui/components/button';
import { UpgradeModal } from '@components/common/UpgradeModal';

import requests from '@vuex/requests.js';

import { queries } from '@/queries/index.js';
import { RouterLink } from 'vue-router';
import ResumeNotice from './ResumeNotice.vue';

const queryClient = useQueryClient();
const store = useStore();
const props = defineProps({
  workspace: {
    type: Object,
    required: true,
  },
});

const canResumeSubscription = computed(() => {
  return (
    props.workspace?.current_subscription_plan?.active &&
    props.workspace?.current_subscription_plan?.end_date !== null
  );
});

const isPastDue = computed(() => store.getters['workspace/getIsPastDue']);

const { isPending, mutate: resumeMutation } = useMutation({
  mutationFn: async () => {
    const res = await requests.workspaces.subscription.resumeSubscription(
      store.getters['workspace/getId']
    );
    return res;
  },
  onSuccess: async res => {
    await queryClient.invalidateQueries({
      queryKey: queries.workspace.current.queryKey,
    });
    toast.success('Your subscription has been resumed');
  },
  onError: async err => {
    console.error(err);
    toast.error('Something went wrong, please try again later');
  },
});

const resumeSubscription = async () => {
  await resumeMutation();
};
</script>
